function getDeviceId() {
  let deviceId = '';
  if (typeof document !== 'undefined') {
    for (const cookie of document.cookie.split(/;\s?/)) {
      const [key, value] = cookie.split('=');
      if (key === 'cookie_id') {
        deviceId = value || '';
        break;
      }
    }
  }
  return deviceId;
}

export const getDeviceIdWithoutHmac = (defaultValue = crypto.randomUUID()) => {
  const deviceId = getDeviceId();
  return deviceId.length > 0
    ? deviceId.slice(deviceId.length - 36)
    : defaultValue.slice(defaultValue.length - 36);
};
